import { GridWidget } from "models/dashboard";
import { DashboardWidget } from "models/workspace";

import { resolveExplicitNormalizationUnits } from "../../../entities/charts/eva/features";
import { IChartSettings } from "../../../models/chart";
import { ChartWidgetKey } from "../constants/widgets.constants";
import { translateOldChartSettingsToNewChartSettings } from "./setGridLayoutItemComponentState";

export function applyNormalizationAndProductionSettingsChartBeta(
  gridLayoutItem: GridWidget,
  item: DashboardWidget,
  isHardRefresh: boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  previousGlobalSettings: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentGlobalSettings: any
) {
  if (isHardRefresh && gridLayoutItem.component === ChartWidgetKey) {
    // need to convert the saved settings if they are still in the old chart format
    // saved settings are the chart settings coming from the saved dashboard settings
    let savedSettings = JSON.parse(item.settings);
    const isSavedSettingsInOldFormat = "chartTypeId" in savedSettings;
    if (isSavedSettingsInOldFormat) {
      savedSettings = translateOldChartSettingsToNewChartSettings(
        savedSettings as IChartSettings,
        item.type
      );
    }
    gridLayoutItem.componentState.features.normalization = {
      ...savedSettings?.features?.normalization
    };
    // DB JSON drops undefined, so a unitless field loses its `units` key.
    // Set it to null so deepMerge doesn't fall back to DEFAULT_NORMALIZATION_UNITS.
    const savedNormProps =
      gridLayoutItem.componentState.features.normalization?.properties;
    if (savedNormProps) {
      savedNormProps.units = resolveExplicitNormalizationUnits(savedNormProps.units);
    }
    gridLayoutItem.componentState.features.timeStep.properties.value =
      savedSettings?.features?.timeStep?.properties?.value;
    gridLayoutItem.componentState.features.source.properties.value =
      savedSettings?.features?.source?.properties?.value;
    // Restore per-chart specific-public-source override from the saved (DB) settings so
    // that stale session data cannot override the last persisted value on hard refresh.
    // Assign directly — do NOT use ?? or || because gDC == 0 is falsy.
    gridLayoutItem.componentState.features.source.properties.specificPublicSource =
      savedSettings?.features?.source?.properties?.specificPublicSource;
  } else if (gridLayoutItem.component === ChartWidgetKey) {
    // this is to ensure when switching between dashboards that the global settings are applied
    if (previousGlobalSettings.useNormalizeBy !== currentGlobalSettings.useNormalizeBy) {
      gridLayoutItem.componentState.features.normalization.properties.useNormalizeBy =
        currentGlobalSettings.useNormalizeBy;
      gridLayoutItem.componentState.features.normalization.active =
        currentGlobalSettings.useNormalizeBy;
    }
    if (previousGlobalSettings.normalizeBy !== currentGlobalSettings.normalizeBy) {
      gridLayoutItem.componentState.features.normalization.properties = {
        //overwrite the properties of the normalization object with global settings
        ...gridLayoutItem.componentState.features.normalization.properties,
        ...currentGlobalSettings.normalizeBy,
        displayName: currentGlobalSettings.normalizeBy.display,
        // undefined (unitless field) must become null so deepMerge doesn't fall back to
        // DEFAULT_NORMALIZATION_UNITS when createFeatureEntities rebuilds the chart entity.
        units: resolveExplicitNormalizationUnits(currentGlobalSettings.normalizeBy.units)
      };
    }
    if (previousGlobalSettings.timeStep !== currentGlobalSettings.timeStep) {
      gridLayoutItem.componentState.features.timeStep.properties.value =
        currentGlobalSettings.timeStep;
    }
    if (previousGlobalSettings.source !== currentGlobalSettings.source) {
      gridLayoutItem.componentState.features.source.properties.value =
        currentGlobalSettings.source;
      // When the global source mode changes, clear any per-chart specific-public-source
      // override so the chart follows the new global mode cleanly.
      // gDC == 0, but resetting on mode change is always correct here.
      gridLayoutItem.componentState.features.source.properties.specificPublicSource =
        undefined;
    }
  }
}
